var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnBnbMen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "btn_bnb_men_svg__a",
  cx: 0.5,
  cy: 0.418,
  r: 1.491,
  gradientTransform: "matrix(0 1 -1.433 0 1.099 -.082)",
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666"
})))), /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  rx: 30,
  style: {
    fill: "url(#btn_bnb_men_svg__a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M-6.125 0h2v-9.338h-2.8l-2.266 5.824-2.268-5.824h-2.786V0h1.988v-6.72L-9.625 0h.868l2.632-6.72zm3.85 0h6.608v-1.722h-4.62v-2.17h4.522V-5.6H-.287v-2.03h4.62v-1.708h-6.608zm14.6 0h1.918v-9.338h-1.986v6.048L7.931-9.338H5.887V0h1.988v-6.272z",
  "data-name": "Path 483",
  style: {
    fill: "#fff"
  },
  transform: "translate(30 41)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-7.17-4A4.03 4.03 0 0 0-3.018.156 4.26 4.26 0 0 0 .21-1.26V-4.2h-3.768v1.056H-.99V-1.7a3.1 3.1 0 0 1-2.028.792A2.917 2.917 0 0 1-5.934-4a2.9 2.9 0 0 1 2.916-3.068 2.76 2.76 0 0 1 2.2 1.08l.968-.564a3.76 3.76 0 0 0-3.168-1.584A4.02 4.02 0 0 0-7.17-4M4.29.144A2.873 2.873 0 0 0 7.218-2.9 2.87 2.87 0 0 0 4.29-5.94 2.877 2.877 0 0 0 1.362-2.9 2.88 2.88 0 0 0 4.29.144m0-.96A1.89 1.89 0 0 1 2.49-2.9a1.884 1.884 0 0 1 1.8-2.08 1.877 1.877 0 0 1 1.8 2.08 1.88 1.88 0 0 1-1.8 2.084",
  "data-name": "Path 482",
  style: {
    fill: "#fff"
  },
  transform: "translate(25 24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.108 22.726 3.4 3.4-3.4 3.4",
  "data-name": "Path 397",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round"
  },
  transform: "translate(-6.107 -5.726)"
}));
export default SvgBtnBnbMen;